module.exports = __webpack_public_path__ + "static/img/pro-img0.556ad4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pro-img0.jpg
// module id = c0aR
// module chunks = 0